function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b4c972da\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Star.vue")
}
var Component = require("!../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Star.vue"),
  /* template */
  require("!!../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b4c972da\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Star.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b4c972da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/blocks/cards/review/components/stars/components/star/Star.vue
// module id = 84d22ccafd3ab7e54bdd
// module chunks = 89